import RootMessageHub from '../slave';
import PushCode from './pushSource/key';
import CustomSourceKey from './customSource/key';
import { orderBranch, phfOrderBranch } from './branches';

export const messageHub = new RootMessageHub<PushCode, CustomSourceKey>();

export const orderMessageHub = messageHub.pipe(orderBranch);

export const phfOrderMessageHub = messageHub.pipe(phfOrderBranch);
